import React from "react";
import moment from "moment";

const OrderViewModal = ({ isOpen, onClose, order }) => {
  if (!isOpen || !order) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center px-4 animate-fadeIn">
      <div className="relative w-full max-w-5xl max-h-[90vh] overflow-y-auto bg-gray-900/60 backdrop-blur-lg border border-purple-700 rounded-2xl shadow-2xl p-6 text-white animate-scaleIn custom-scrollbar">

        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-5 text-white text-3xl font-bold hover:text-red-500 transition-transform hover:scale-110"
          aria-label="Close"
        >
          &times;
        </button>

        {/* Header */}
        <h2 className="text-3xl font-extrabold text-center mb-8 text-transparent bg-clip-text bg-gradient-to-r from-pink-500 via-purple-500 to-cyan-400 drop-shadow-md">
          Order #{order.displayId || order.order_no}
        </h2>

        {/* Sections */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
          {/* Customer Info */}
          <div className="bg-gray-800/50 p-4 rounded-xl shadow-inner border border-purple-600 space-y-2">
            <h3 className="text-lg font-semibold text-purple-400 mb-2">
              👤 Delivery Info
            </h3>
            <p><span className="font-semibold text-white/70">Name:</span> {order.name}</p>
            <p><span className="font-semibold text-white/70">Phone:</span> {order.phone_number}</p>
            <p><span className="font-semibold text-white/70">Email:</span> {order.email}</p>
            <p><span className="font-semibold text-white/70">Location:</span> {order.location}, {order.city}, {order.state}, {order.country} - {order.zip_code}</p>
            <p><span className="font-semibold text-white/70">Notes:</span> {order.notes || 'N/A'}</p>
          </div>

          {/* Order Info */}
          <div className="bg-gray-800/50 p-4 rounded-xl shadow-inner border border-pink-600 space-y-2">
            <h3 className="text-lg font-semibold text-pink-400 mb-2">
              📦 Order Info
            </h3>
            <p><span className="font-semibold text-white/70">Order No:</span> {order.order_no}</p>
            <p><span className="font-semibold text-white/70">Date:</span> {moment(order.date_time, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm")}</p>
            <p><span className="font-semibold text-white/70">Total:</span> ₹{parseFloat(order.amount || 0).toFixed(2)}</p>
            <p><span className="font-semibold text-white/70">Status:</span> 
              <span className={`ml-2 px-2 py-1 text-xs font-semibold rounded-full
                ${order.order_status === "Pending" && "bg-yellow-500/10 text-yellow-300"}
                ${order.order_status === "Processing" && "bg-blue-500/10 text-blue-300"}
                ${order.order_status === "Shipped" && "bg-indigo-500/10 text-indigo-300"}
                ${order.order_status === "Delivered" && "bg-green-500/10 text-green-300"}
              `}>
                {order.order_status}
              </span>
            </p>
            <p><span className="font-semibold text-white/70">Is Paid:</span>
              <span className={`ml-2 px-2 py-1 text-xs font-semibold rounded-full
                ${order.is_paid === "YES" ? "bg-green-500/10 text-green-300" : "bg-red-500/10 text-red-300"}
              `}>
                {order.is_paid === "YES" ? "Yes" : "No"}
              </span>
            </p>
            <p><span className="font-semibold text-white/70">Coupon:</span> {order.coupon_status || 'No'}</p>
          </div>
        </div>

        {/* Payment Info
        <div className="mb-10 bg-gray-800/50 p-4 rounded-xl border border-cyan-500 shadow-inner">
          <h3 className="text-lg font-semibold text-cyan-400 mb-2">💳 Payment Details</h3>
          <p><span className="font-semibold text-white/70">Razorpay Order ID:</span> {order.razorpay_order_id || 'N/A'}</p>
          <p><span className="font-semibold text-white/70">Razorpay Payment ID:</span> {order.razorpay_payment_id || 'N/A'}</p>
        </div> */}

        {/* Items */}
        <div className="bg-gray-800/50 p-4 rounded-xl border border-purple-700 shadow-inner mb-6">
          <h3 className="text-xl font-extrabold mb-4 text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-purple-400">
            🧾 Order Items
          </h3>

          {order.items?.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="min-w-full text-sm text-left">
                <thead className="bg-gradient-to-r from-purple-700 to-pink-600 text-white uppercase text-xs">
                  <tr>
                    <th className="px-6 py-3">Product</th>
                    <th className="px-6 py-3">Quantity</th>
                    <th className="px-6 py-3">Price</th>
                  </tr>
                </thead>
                <tbody className="bg-gray-900 divide-y divide-gray-800 text-white/90">
                  {order.items.map((item, i) => (
                    <tr key={item._id || i}>
                      <td className="px-6 py-4">{item.product_name}</td>
                      <td className="px-6 py-4">{item.quantity}</td>
                      <td className="px-6 py-4">₹{Math.round(item.price)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="italic text-gray-400">No items found in this order.</p>
          )}
        </div>

        {/* Close Button Bottom */}
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="px-6 py-2 rounded-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-pink-600 hover:to-purple-600 text-white font-semibold shadow-lg transition hover:scale-105"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderViewModal;
